module.exports = __webpack_public_path__ + "static/media/flay.957209fd.jpg";